function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import MUIModal from '@mui/material/Modal';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';
import colors from '#src/colors';
import theme from '#src/theme';
import { color, radius, shadow } from '#src/design/tokens';
const styles = createUseStyles({
  container: {
    backgroundColor: colors.white,
    padding: '1.25rem',
    color: color.ink,
    border: `${theme.borderThickness}px solid ${color.border}`,
    borderRadius: `${radius.lg}px`,
    boxShadow: shadow.lg,
    animation: 'tb-pop 260ms cubic-bezier(.34, 1.56, .64, 1)',
    outline: 0,
    maxWidth: '100%',
    boxSizing: 'border-box'
  }
});

// //@ts-ignore
// interface ModalProps extends React.ComponentProps<typeof MUIModal> {
//   children: React.ReactNode;
//   className?: string;
//   style?: React.CSSProperties;
// }

const Modal = ({
  children,
  className,
  style,
  ...props
}) => {
  const classes = styles();
  return /*#__PURE__*/React.createElement(MUIModal, _extends({
    style: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, props), /*#__PURE__*/React.createElement("div", {
    className: classNames(classes.container, className),
    style: style
  }, children));
};
export default Modal;